import { SvgIcon } from '@mui/material'

export const CommunityOutlinedIcon = (props) => (
  <SvgIcon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M15.5001 5.96667C15.4501 5.95834 15.3918 5.95834 15.3418 5.96667C14.1918 5.925 13.2751 4.98334 13.2751 3.81667C13.2751 2.625 14.2335 1.66667 15.4251 1.66667C16.6168 1.66667 17.5751 2.63334 17.5751 3.81667C17.5668 4.98334 16.6501 5.925 15.5001 5.96667Z"
      strokeWidth="1.47692"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M14.6417 12.0333C15.7834 12.225 17.0417 12.025 17.925 11.4333C19.1 10.65 19.1 9.36668 17.925 8.58334C17.0334 7.99168 15.7584 7.79167 14.6167 7.99167"
      strokeWidth="1.47692"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5.47515 5.96667C5.52515 5.95834 5.58348 5.95834 5.63348 5.96667C6.78348 5.925 7.70015 4.98334 7.70015 3.81667C7.70015 2.625 6.74181 1.66667 5.55015 1.66667C4.35848 1.66667 3.40015 2.63334 3.40015 3.81667C3.40848 4.98334 4.32515 5.925 5.47515 5.96667Z"
      strokeWidth="1.47692"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M6.33353 12.0333C5.19186 12.225 3.93353 12.025 3.0502 11.4333C1.8752 10.65 1.8752 9.36668 3.0502 8.58334C3.94186 7.99168 5.21686 7.79167 6.35853 7.99167"

      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M10.5004 12.1917C10.4504 12.1833 10.3921 12.1833 10.3421 12.1917C9.19206 12.15 8.27539 11.2083 8.27539 10.0417C8.27539 8.85 9.23372 7.89167 10.4254 7.89167C11.6171 7.89167 12.5754 8.85834 12.5754 10.0417C12.5671 11.2083 11.6504 12.1583 10.5004 12.1917Z"

      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M8.07534 14.8167C6.90034 15.6 6.90034 16.8833 8.07534 17.6667C9.40868 18.5583 11.592 18.5583 12.9253 17.6667C14.1003 16.8833 14.1003 15.6 12.9253 14.8167C11.6003 13.9333 9.40868 13.9333 8.07534 14.8167Z"

      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
)
